import gql from 'graphql-tag';

export const SEARCH_MODELS = gql`
  query ListReferenceLineItems(
    $receiveReferenceIdList: [String]
    $mpn: String
    $noRefShipmentId: String
    $paginationSize: Int
    $paginationNextTokens: ListReferenceLineItemsNextTokensRequest
  ) {
    listReferenceLineItems(
      receiveReferenceIdList: $receiveReferenceIdList
      mpn: $mpn
      noRefShipmentId: $noRefShipmentId
      paginationSize: $paginationSize
      paginationNextTokens: $paginationNextTokens
    ) {
      mpnToIpnMapping {
        associatedIpns {
          ipn
          description
          manufacturer
          materialDefintionId
        }
        mpn
      }
      paginationNextTokens {
        mpnToIpnMappingToken
        referenceLineItemsToken
      }
      referenceLineItems {
        refereceLineItem {
          currentReceivedQuantity
          expectedIPN
          expectedMPN
          expectedMaterialDefinitionId
          manufacturer
          maximumExpectedQuantity
          orderLineItemNumber
          orderNumber
          orderedIPN
          orderedMaterialCategory
          orderedMaterialDefinitionId
          orderedQuantity
          referenceId
          referenceLineItemId
          externalReferenceValue
          externalReferenceLineItemNumber
          externalReferenceType
          buildId
          buildCategory
          tags
          orderReferenceId
          orderReferenceLineItemId
          rmaID
          rmaLineItemNumber
          requisitionId
          requisitionLineItemNumber
          wwFaId
          wwFaLineItemNumber
          referenceLineItemStatus
        }
        status {
          statusCode
          statusMessage
          validationStatusType
        }
      }
    }
  }
`;

export const SEARCH_PO_ASNS = gql`
  query GetASNReferences(
    $mpn: String
    $externalReferenceValue: String
    $paginationSize: Int
    $paginationToken: String
  ) {
    getASNReferences(
      externalReferenceValue: $externalReferenceValue
      mpn: $mpn
      paginationSize: $paginationSize
      paginationToken: $paginationToken
    ) {
      paginationNextToken
      asnReferencesList {
        receiveReference {
          receiveReferenceId
          externalReferenceValue
          externalReferenceType
          expectedReceiveLocation
          expectedDeliveryDateTime
          supplier
          trackingId
          carrier
          siteName
          clusterName
          referenceStatus
          scannableId
        }
      }
    }
  }
`;

export const SUGGEST_MODELS = gql`
  query GetMpnAutoCorrection(
    $referenceId: String
    $expectedMPNPrefix: String
  ) {
    getMpnAutoCorrection(
      referenceId: $referenceId
      expectedMPNPrefix: $expectedMPNPrefix
    ) {
      validMPN
      message
    }
  }
`;
